import './App.css';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppState, useSelector } from './store/Store';
import { useRoutes } from 'react-router-dom';
import { Router } from './router/Router';


function App() {
  const router = useRoutes(Router);
  const customizer = useSelector((state: AppState) => state.customizer);
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(customizer.isLanguage);
  },[customizer.isLanguage, i18n]);
  
  useEffect(() => {
    document.body.setAttribute('lang', customizer.isLanguage ?? 'en')
  }, [customizer.isLanguage])


  return (
    <div translate="no" dir={customizer.activeDir}>
      {router}
    </div>

  );
}

export default App;
